export default __webpack_public_path__ + "static/media/ARENA.78998779.png";